"use client"

import { useCategoryStore } from "@/(admin)/modules/ui-builder/config/themes/tamda-one/PromotionList/store/CategoryStore"
import { useUIBuilderLocaleStore } from "@/(admin)/modules/ui-builder/store/useUIBuilderLocaleStore"
import { PostSelectProps, PromotionListRenderProps } from "@/types/types"
import { ComponentConfig, CustomField } from "@measured/puck"
import { useEffect, useMemo } from "react"
import { CategorySelect, CategorySelectProps } from "../../../components/CategorySelect"
import { PostSelect } from "./components/PostSelect"
import { RenderConfig } from "./RenderConfig"

let instanceCounter = 0
const instanceIdMap = new Map<string, string>()

const getOrCreateInstanceId = (componentKey: string): string => {
  const globalKey = `promotion-list-${componentKey}`

  if (!instanceIdMap.has(globalKey)) {
    const newInstanceId = `promotion-list-instance-${instanceCounter++}`
    instanceIdMap.set(globalKey, newInstanceId)
    return newInstanceId
  }

  return instanceIdMap.get(globalKey)!
}

const CategorySelectWrapper = (props: CategorySelectProps) => {
  const componentKey = "promotion-list-shared"
  const instanceId = useMemo(() => getOrCreateInstanceId(componentKey), [])
  const setCategoryId = useCategoryStore(state => state.setCategoryId)
  const locale = useUIBuilderLocaleStore(state => state.locale)

  useEffect(() => {
    if (props.value?.categoryId) {
      setCategoryId(instanceId, props.value.categoryId)
    }
  }, [props.value?.categoryId, instanceId, setCategoryId])

  const handleChange = (value: { categoryId: number; categoryName: string; slug?: string } | undefined) => {
    if (value?.categoryId) {
      setCategoryId(instanceId, value.categoryId)
    } else {
      setCategoryId(instanceId, null)
    }
    props.onChange(value)
  }

  return <CategorySelect {...(props as CategorySelectProps)} requireWebsite={false} onChange={handleChange} locale={locale} />
}

const PostSelectWrapper = (props: any) => {
  const componentKey = "promotion-list-shared"
  const instanceId = useMemo(() => getOrCreateInstanceId(componentKey), [])
  const categoryId = useCategoryStore(state => state.categoryMap.get(instanceId) || null)

  return (
    <PostSelect
      {...(props as PostSelectProps)}
      categoryId={categoryId}
      value={props.value as number | undefined}
      onChange={props.onChange}
      pageSize={20}
    />
  )
}

export const PromotionList: ComponentConfig<PromotionListRenderProps> = {
  label: "Tamda One | Promotion List",
  fields: {
    title: {
      label: "Title",
      type: "text",
    },
    viewAllLink: {
      label: "View All Link",
      type: "text",
    },
    category: {
      label: "Category",
      type: "custom",
      render: (props: CategorySelectProps) => <CategorySelectWrapper {...(props as CategorySelectProps)} />,
    } as CustomField<{ categoryId: number; categoryName: string; slug?: string } | undefined>,
    pageSize: {
      label: "Page Size",
      type: "custom",
      render: (props: any) => {
        return <PostSelectWrapper {...props} />
      },
    } as CustomField<number | undefined>,
    slidesPerView: {
      label: "Slides Per View",
      type: "number",
      min: 1,
      max: 5,
    },
    spaceBetween: {
      label: "Space Between (px)",
      type: "number",
      min: 0,
      max: 100,
    },
    className: {
      label: "Class Name",
      type: "text",
    },
  },
  defaultProps: {
    title: "Khuyến Mãi",
    viewAllLink: "/category/sale-and-promotions",
    category: {
      categoryId: 43,
      categoryName: "Khuyến Mãi",
      slug: "sale-and-promotions",
    },
    pageSize: 20,
    slidesPerView: 3,
    spaceBetween: 20,
    className: "",
  },
  ...RenderConfig,
}
